export const isAdminUser = (user) => {
  if (!user) return false;

  const role = (user.role || user.user_type || "").toString().toLowerCase();
  return role === "admin" || user.is_admin === true;
};

export const isAdminOrFacultyUser = (user) => {
  if (!user) return false;

  const role = (user.role || user.user_type || "").toString().toLowerCase();
  return (
    role === "admin" ||
    role === "faculty" ||
    user.is_admin === true ||
    user.is_faculty === true
  );
};
